import actions from './actions'
import { factoryReducer } from '../factory'

// Defining the Initial Variables to be saved in the Redux Store on initialize.
const initialState = {
  devices: [],
  totalDevices: 0,

  devicesRecord: [],
  totalDevicesRecord: 0,

  devicesInventory: [],
  totalDevicesInventory: 0,

  devicesConnection: [],
  totalDevicesConnection: 0,

  loading: false,
  lastTimezone: 0,
  deviceActivity: [],
  reportDeviceSessions: [],
  redirect: false,
  formLoading: false,
  deviceForm: '',
  inventoryLoading: false,
  inventoryDevices: [],

  inventoryDevicesList: [],
  modalLoading: false,
  modalVisible: false,
  assignModalLoading: false,
  assignModalVisible: false,
  deviceDetail: [],
  deviceSessions: [],
  patientLinkLoading: false,
  patientModalVisible: false,
  patientSessionDates: [],
  devicePatients: [],
  devicePatientsLoading: false,
  patientSessionsLoading: false,
  modalVisibleDeviceName: false,
  deviceNameModalLoading: false,
  socketResponse: false,

  inventoryListingLoading: false,
  inventoryListingDevices: [],
  totalInventoryDeviceRecords: 0,
  inventoryListingDevicesPageSize: 10,
  inventoryListingDevicesPageNumber: 1,
  roomDirectoryActiveTab: '1',

  deviceMetricsLoading: false,
  deviceMetrics: {
    disconnected_devices_percentage: 0,
    installed_devices: 0,
    total_admitted_patients: 0,
    total_clinics: 0,
    total_connected_patients: 0,
    total_disconnected_devices: 0,
    total_online_devices: 0,
  },

  addSingleDeviceStatus: '',
  addMultipleDeviceStatus: '',
  replaceDevicesStatus: '',
  replaceDevicesResponse: null,
}

export default factoryReducer(initialState, actions)
